import { API_ENDPOINTS } from '../config/api';

export function isPushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function getExistingPushSubscription() {
  if (!isPushSupported()) return null;
  const registration = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!registration) return null;
  return registration.pushManager.getSubscription();
}

/** Registers the service worker, requests permission, subscribes, and saves the subscription server-side. `authHeaders` must come from a logged-in customer. */
export async function enablePushNotifications(authHeaders) {
  if (!isPushSupported()) {
    throw new Error('Push notifications are not supported in this browser.');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission was not granted.');
  }

  const registration = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;

  const res = await fetch(API_ENDPOINTS.push.vapidPublicKey);
  const { publicKey } = await res.json();
  if (!publicKey) throw new Error('Push notifications are not configured right now.');

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  const subRes = await fetch(API_ENDPOINTS.customerPush.subscribe, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders },
    body: JSON.stringify({ subscription: subscription.toJSON() }),
  });
  if (!subRes.ok) {
    const data = await subRes.json().catch(() => ({}));
    throw new Error(data.error || 'Could not save your notification subscription.');
  }

  return subscription;
}
